// ---- Client-facing contact details (edit these, then rebuild the frontend) ----
// WhatsApp number in international format, digits only (no +, spaces, or dashes).
export const CONTACT_WHATSAPP = '972549573533';
export const CONTACT_NAME = 'David Barilier';
export const CONTACT_COMPANY = 'Skyhigh Dubai';

export const waLink = (text) =>
  `https://wa.me/${CONTACT_WHATSAPP}` + (text ? `?text=${encodeURIComponent(text)}` : '');
